import { render, staticRenderFns } from "./DeparturePurposeSummary.vue?vue&type=template&id=72077393&"
import script from "./DeparturePurposeSummary.vue?vue&type=script&lang=js&"
export * from "./DeparturePurposeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports